import { Field, Form, FormElement } from '@progress/kendo-react-form';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { Splitter } from '@progress/kendo-react-layout';
import React, { useEffect, useState } from 'react'
import { utility } from '../../framework/utility/utilityProvider';
import { useTranslation } from '../../locale/useTranslation'
import * as API from '../../framework/API/api'
import { ENTITYNAME, LOCALSTORAGE_KEY, LOGEVENT, MEDIACATEGORIES, MODULE, TOAST_TYPES, VERSION_TYPE } from '../../framework/constant/constant';
import SegmentTypeCollectionTab from '../Segment/SegemnetTypeCollectionTab';
import { Checkbox } from '@progress/kendo-react-inputs';
import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import { EditPageHeader } from '../../components/EditPageHeader';
import BossDialog from '../../components/BossDialog';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import ToastNotification from '../../components/ToastNotification';

const MultiVersioningForm = (props) => {

  const lang = useTranslation();
  let initialValue = {
    ActualDuration: utility.convertMilisecondsToStringWithFrames(0),
    SegmentType: {},
    SegmentNumber: '',
    SegmentDetails: [],
    IsHardParted: false,
    IsDefault: false,
    TXReady: false,
    GenerateMaterialID: false,
    MaterialContent: {},
    TransmissionType: {},
    VersionType: { _id: VERSION_TYPE.Linear, Description: utility.getKeyByValue(VERSION_TYPE, VERSION_TYPE.Linear) },
    PgRating: {},
    Archive: false
  }
  const [dataItem, setDataItem] = useState(initialValue);
  let segmentDetail = {
    MediaEpisodeSegmentSID: 0,
    Sequence: 0,
    MediaId: "",
    TcIn: '00:00:00:00',
    TcOut: '',
    Duration: '',
    IsPreviewed: false
  };
  const [materialContent, setMaterialContent] = useState([]);
  const [segmentTypes, setSegmentTypes] = useState([]);
  const [segmentDetails, setSegmentDetails] = useState([]);
  const [horizontalPanes, setHorizontalPanes] = useState([
    {
      size: "30%",
      collapsible: true
    },
    {},
  ]);
  const [transmissionTypes, setTransmissionTypes] = useState([]);
  const [filterTransmissionTypes, setFilterTransmissionTypes] = useState([]);
  const [pgRatings, setPgRatings] = useState([]);
  const [channels, setChannels] = useState([]);
  const [showChannelGroups, setShowChannelGroups] = useState(false);
  const [selectAllChannels, setSelectAllChannels] = useState(false);

  // company Data
  const companyData = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

  useEffect(() => {
    loadcombo();
  }, []);

  const loadcombo = async () => {
    let segmentTypeRes = await API.getDataLookup(ENTITYNAME.SegmentType, { sort: { Description: 1 } });
    setSegmentTypes(segmentTypeRes.data);
    let materialContentRes = await API.getDataLookup(ENTITYNAME.MaterialContent, { sort: { Description: 1 } });
    setMaterialContent(materialContentRes.data.filter((x) => x.MediaCategory.SID == MEDIACATEGORIES.Episode));
    // PG Rating
    let pgRatingRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
    setPgRatings(pgRatingRes.data);
    // CHANNELS
    let channelRes = await API.getValidChannels();
    setChannels(channelRes.data);
    // TRANSMISSION TYPE
    const transmissionTypesRes = await API.getDataLookup(ENTITYNAME.TransmissionTypes, { sort: { Description: 1 } });
    const transmissionTypeData = transmissionTypesRes?.data ?? [];
    setTransmissionTypes(transmissionTypeData);

    // TRANSMISSION TYPES
    const isLinear = dataItem.VersionType?._id === VERSION_TYPE.Linear;
    setFilterTransmissionTypes(transmissionTypesRes?.data?.filter(({ Name }) =>
      isLinear
        ? Name?.toLowerCase() === "linear"
        : Name?.toLowerCase() !== "linear"
    ));

    if (transmissionTypeData?.length > 0) {
      setDataItem({ ...dataItem, TransmissionType: isLinear ? transmissionTypeData?.find(t => t.Name?.toLowerCase() === "linear") : transmissionTypeData?.find(t => t.Name?.toLowerCase() === "svod") });
    }
  }

  const onHorizontalSplitterChange = (event) => {
    setHorizontalPanes(event.newState);
  };

  const onChange = async (e) => {
    if (e.target.name === "IsAllChannel") {
      const newValue = !selectAllChannels;
      setSelectAllChannels(newValue);
      setDataItem({
        ...dataItem,
        Channels: newValue ? channels : []
      });
    } else if (e.target.name === "Channels") {
      if (e.target.value.length === channels.length) {
        setSelectAllChannels(true);
      } else {
        setSelectAllChannels(false);
      }
      setDataItem({
        ...dataItem,
        Channels: e.target.value
      });
    } else if (e.target.name == "VersionType") {
      if (e.target.value?._id === VERSION_TYPE.Linear) {
        const filteredLinearTransmissionTypes = transmissionTypes.filter((x) => x?.Name?.toLowerCase() === "linear");
        setFilterTransmissionTypes(filteredLinearTransmissionTypes);
        setDataItem({ ...dataItem, [e.target.name]: e.target.value, TransmissionType: filteredLinearTransmissionTypes.length > 0 ? filteredLinearTransmissionTypes[0] : {} });
      } else if (e.target.value?._id === VERSION_TYPE.NonLinear) {
        const filteredNonLinearTransmissionTypes = transmissionTypes.filter((x) => x?.Name?.toLowerCase() !== "linear");
        setFilterTransmissionTypes(filteredNonLinearTransmissionTypes);
        setDataItem({ ...dataItem, [e.target.name]: e.target.value, TransmissionType: filteredNonLinearTransmissionTypes.length > 0 ? filteredNonLinearTransmissionTypes.find((x) => x?.Name?.toLowerCase() === "svod") : {} });
      } else {
        setFilterTransmissionTypes(transmissionTypes);
        setDataItem({ ...dataItem, [e.target.name]: e.target.value, TransmissionType: {} });
      }
    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }
  }

  const isValid = () => {
    if (!dataItem.SegmentType || Object.keys(dataItem.SegmentType).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_segment_type_error_message });
      return false;
    }
    if (!dataItem.VersionType || Object.keys(dataItem.VersionType).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_version_type_error_message });
      return false;
    }
    if (segmentDetails.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_generate_segments_first_media_episode_version_error_message });
      return false;
    }
    return true;
  }

  const onSave = async () => {

    if (!isValid()) return;

    //to remove idEdit property from segment detail obj
    segmentDetails.forEach((obj) => {
      delete obj.inEdit;
    })

    const saveSegmentData = {
      SID: 0,
      SegmentType: dataItem.SegmentType,
      ActualDuration: utility.convertStringWithFramesToMilliseconds(dataItem.ActualDuration),
      SegmentNumber: '', //create in backend
      IsHardParted: dataItem.IsHardParted ?? false,
      TXReady: dataItem.TXReady ?? false,
      IsDefault: dataItem.IsDefault ?? false,
      Archive: dataItem.Archive ?? false,
      Subtitle: false,
      SubtitleType: {},
      File: "",
      SegmentDetails: segmentDetails.map(item => ({
        ...item, ["TcIn"]: utility.convertStringWithFramesToMilliseconds(item.TcIn),
        ["TcOut"]: utility.convertStringWithFramesToMilliseconds(item.TcOut), ["Duration"]: utility.convertStringWithFramesToMilliseconds(item.Duration)
      })),
      TransmissionType: dataItem?.TransmissionType?._id ? {
        _id: dataItem?.TransmissionType?._id,
        Name: dataItem?.TransmissionType?.Name,
        IsDefault: dataItem?.TransmissionType?.IsDefault
      } : {},
      PgRating: dataItem?.PgRating?._id ? {
        _id: dataItem.PgRating._id,
        Description: dataItem.PgRating.Description
      } : {},
      VersionType: dataItem?.VersionType?._id,
      Channels: dataItem.Channels?.length > 0 ? dataItem.Channels?.map(x => {
        return {
          _id: x._id,
          SID: x.SID,
          FullChannelName: x.FullChannelName
        }
      }) : [],
    }

    //send this dataItem to API saveSegmentData
    let payload = {
      item: saveSegmentData,
      episodes: props.selectedData?.length > 0 ? props.selectedData.map(x => {
        return {
          _id: x._id,
          SID: x.SID,
          Title: x.Title,
          SeasonNumber: x.SeasonNumber,
          EpisodeNumber: x.EpisodeNumber,
          ReferenceCode: x.ReferenceCode,
          AssetId: x.AssetId,
          EpisodeTitle: x.EpisodeTitle,
          Provider: x.Provider,
          MediaCategory: x.MediaCategory,
          CustomTitle: x.CustomTitle,
          WorkingTitle: x.WorkingTitle,
          DealReference: x.DealReference
        }
      }) : [],
      generateMaterialID: dataItem.GenerateMaterialID ?? false,
      materialContent: dataItem.MaterialContent ?? {},
      segByRc: companyData.segByRc ?? false
    }

    console.log(payload);
    let res = await API.createMultipleEpisodeVersions(payload);
    console.log(res);

    if (res.success) {
      // res.skippedEpisodes.length > 0
      ToastNotification({
        type: TOAST_TYPES.INFO, title: lang.info_message_title, message: res.skippedEpisodes.length > 0 ?
          `Episode No. ${res.skippedEpisodes.join(', ')} are skipped because it has same type of segment already exists` :
          `${res.message}`
      });
      props?.selectedData?.forEach((item) => {
        let logData = { event: LOGEVENT.UPDATE_EPISODE, module: MODULE.EPISODE, data: { ...item, saveSegmentData: saveSegmentData, materialContent: dataItem?.MaterialContent }, message: res.message };
        API.SaveLogs(logData);
      })
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }

    clearData();
  }

  const generateSegment = function (e) {

    let segmentCount = dataItem.SegmentType.SegmentCount;

    if (segmentCount) {

      if (props.selectedData[0] === null || props.selectedData[0].Duration === null) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.media_episode_entity_duration_segment_error_message });
        return;
      }

      let segmentDetails = [];
      let episodeDuration = utility.convertMilisecondsToStringWithFrames(props.selectedData[0].Duration);
      let actualSegmentDuration = calculateSegmentDuration(episodeDuration, segmentCount)  //to generate the function to calculate segment duration in utility folder

      let durationAsString = actualSegmentDuration;

      for (let cnt = 1; cnt <= segmentCount; cnt++) {

        if (dataItem.IsHardParted) {

          segmentDetail.Duration = actualSegmentDuration;
          segmentDetail.TcIn = '00:00:00:00';
          let millisecondsTcOut = utility.convertStringWithFramesToMilliseconds(segmentDetail.TcIn) + utility.convertStringWithFramesToMilliseconds(actualSegmentDuration);
          segmentDetail.TcOut = utility.convertMilisecondsToStringWithFrames(millisecondsTcOut);
          segmentDetail.IsPreviewed = false;

        } else {

          segmentDetail.Duration = actualSegmentDuration;
          segmentDetail.TcIn = segmentDetail.TcIn;
          let millisecondsTcOut = utility.convertStringWithFramesToMilliseconds(segmentDetail.TcIn) + utility.convertStringWithFramesToMilliseconds(actualSegmentDuration);
          segmentDetail.TcOut = utility.convertMilisecondsToStringWithFrames(millisecondsTcOut);
          segmentDetail.IsPreviewed = false;

        }

        segmentDetails.push({
          Sequence: cnt,
          MediaId: `${cnt}-${segmentCount}`,  //segmentnumber-selectedsegmenttype.count === for mediaID
          TcIn: segmentDetail.TcIn,
          Duration: durationAsString,
          TcOut: segmentDetail.TcOut,
          IsPreviewed: false
        });
        segmentDetail.TcIn = segmentDetail.TcOut;


      }

      setSegmentDetails(segmentDetails);
      setDataItem({ ...dataItem, ["ActualDuration"]: episodeDuration });

    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_segment_type_media_episode_version_error_message });
    }

  }

  const updatedSegmentDetails = (updatedData) => {
    console.log(updatedData);
    setSegmentDetails(updatedData);
  }

  const handleGenerateSegmentClick = async (e) => {

    e.preventDefault();
    if (dataItem.GenerateMaterialID && Object.keys(dataItem.MaterialContent).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_material_content_error_message });
      return;
    }
    generateSegment();

  }

  const calculateSegmentDuration = function (episodeDuration, segmentCount) {

    const [hours, minutes, seconds, msec] = episodeDuration.split(':');
    let hoursToMilliseconds = parseInt(hours) * 3600000;
    let minutesToMilliseconds = parseInt(minutes) * 60000;
    let secondsToMilliseconds = parseInt(seconds) * 1000;

    let convertedMilliseconds = hoursToMilliseconds + minutesToMilliseconds + secondsToMilliseconds + (parseInt(msec) * 40);

    let result = segmentCount === 0 ? new Date('2000', '1', '1', '0', '0', '0') : utility.convertMilisecondsToStringWithFrames(convertedMilliseconds / segmentCount);
    return result;
  }

  const handleActualDuration = (durationAsString) => {
    dataItem.ActualDuration = durationAsString;
  }

  const clearData = () => {
    setSegmentDetails(() => []);
    setDataItem(() => initialValue);
    props.closeForm();
  }

  const checkInvalidTimecodes = () => {
    if (segmentDetails.length === 0) return false;
    return segmentDetails.some(item => {
      let duration = item.Duration;
      return duration === null || duration === "00:00:00:00" || item.TcIn > item.TcOut;
    });
  }

  const checkExceedingSlotDuration = () => {
    if (segmentDetails.length === 0) return false;
    let isExceeding = props?.mediaEpisodeEntity?.Duration < utility.convertStringWithFramesToMilliseconds(dataItem.ActualDuration);
    return isExceeding;
  }

  const checkOverlappingTimecodes = () => {
    if (segmentDetails.length === 0) return false;

    return segmentDetails.some((currentItem, index) => {
      const nextItem = segmentDetails[index + 1];
      if (!nextItem) return false;

      const currentEnd = utility.convertStringWithFramesToMilliseconds(currentItem.TcOut);
      const nextStart = utility.convertStringWithFramesToMilliseconds(nextItem.TcIn);

      return currentEnd > nextStart && !dataItem?.IsHardParted;
    });
  };

  const handleChannelGroups = (groups = []) => {

    const linkedChannels = groups.flatMap(g => g.LinkedChannels || []);

    const uniqueChannels = Array.from(
      new Map(linkedChannels.map(ch => [ch._id, ch])).values()
    );

    setDataItem(prev => ({
      ...prev,
      Channels: uniqueChannels
    }));

    setSelectAllChannels(uniqueChannels.length === channels.length);

    setShowChannelGroups(false);
  };

  return (
    <BossDialog
      title={'Multi Versioning'}
      onClose={props.closeForm}
      width={"65%"}
    // height={"68%"}
    >
      <EditPageHeader title={""} onSubmit={onSave} onCancel={props.closeForm} showTitle={false} />
      <Splitter panes={horizontalPanes} onChange={onHorizontalSplitterChange} >
        <div>
          <Grid data={props.selectedData} style={{ height: "53vh" }}>
            {/* <GridColumn field="Title" title={lang.title_column} editable={false} /> */}
            <GridColumn field="EpisodeNumber" title={lang.episode_number_column} editable={false} />
            <GridColumn field="AssetId" title={lang.assetId_column} editable={false} />
            <GridColumn field="ReferenceCode" title={lang.reference_code_column} editable={false} />
          </Grid>
        </div>
        <div>
          {/* <div className='col-12'> */}
          <Form
            render={(formRenderProps) => (
              <FormElement>
                <div className="row" style={{ margin: "5px" }}>
                  <div className="col-12 mt-1">

                    <div className="row form-group">
                      <div className="col-4">
                        <label htmlFor="TabView">{lang.segment_type_label} *</label>

                        <DropDownList
                          style={{
                            backgroundColor: "white",
                          }}
                          data={segmentTypes}
                          name="SegmentType"
                          textField="Description"
                          dataItemKey="_id"
                          value={dataItem.SegmentType}
                          onChange={onChange}
                        />

                      </div>


                      <div className="col-4">
                        <label htmlFor="">{lang.version_type_label} *</label>
                        <DropDownList
                          style={{ backgroundColor: "white" }}
                          data={Object.keys(VERSION_TYPE).map((key) => ({ _id: VERSION_TYPE[key], Description: key }))}
                          name="VersionType"
                          textField="Description"
                          dataItemKey="_id"
                          value={dataItem.VersionType}
                          onChange={onChange}
                        />
                      </div>

                      <div className="col-4">
                        <label htmlFor="">{lang.transmission_type_label} </label>
                        <DropDownList
                          style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
                          data={filterTransmissionTypes}
                          name={"TransmissionType"}
                          textField="Name"
                          dataItemKey="_id"
                          value={dataItem.TransmissionType}
                          onChange={onChange}
                        />
                      </div>

                    </div>

                    <div className="row form-group">

                      <div className="col-4">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <label className="mb-0 fw-semibold"> {lang.channel_label} </label>
                          <div className="d-flex align-items-center">
                            <span className="me-1">{lang.select_all_label}</span>
                            <input
                              type="checkbox"
                              name="IsAllChannel"
                              className="ml-1"
                              value={selectAllChannels}
                              checked={selectAllChannels}
                              onChange={(e) => onChange(e)}
                            />
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <div style={{ flex: 1 }}>
                            <MultiSelect
                              data={channels}
                              name="Channels"
                              textField="FullChannelName"
                              dataItemKey="_id"
                              value={dataItem.Channels}
                              onChange={onChange}
                              style={{ maxHeight: "65px" }}
                            />
                          </div>
                          <button
                            type="button"
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success ms-2"
                            style={{ width: "28px", height: "28px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginLeft: "6px" }}
                            title={lang.select_channel_groups_tooltip}
                            onClick={() => setShowChannelGroups(true)}
                          >
                            <i className="fa fa-ellipsis-h" aria-hidden="true" />
                          </button>
                        </div>
                      </div>

                      <div className="col-4">
                        <label htmlFor="">{lang.pg_rating_label}</label>
                        <DropDownList
                          style={{ backgroundColor: "white" }}
                          data={pgRatings}
                          name="PgRating"
                          textField="Description"
                          dataItemKey="_id"
                          value={dataItem.PgRating}
                          onChange={onChange}
                        />
                      </div>
                    </div>

                    <fieldset className="border rounded-4" style={{ padding: '20px 30px', margin: '8px 0px 0px 0px' }}  >
                      <div className="row">
                        <div className={dataItem.GenerateMaterialID ? "col-6" : 'col-12'} style={dataItem.GenerateMaterialID ? { marginTop: '19px' } : {}}>
                          <Field
                            style={{ borderColor: "black" }}
                            name={"GenerateMaterialID"}
                            component={Checkbox}
                            label={'Auto Generate Material ID'}
                            onChange={(e) => onChange(e)}
                            checked={dataItem.GenerateMaterialID}
                          />
                        </div>
                        {dataItem.GenerateMaterialID &&
                          <div className="col-6">
                            <label htmlFor="">{lang.material_content_sub_menu} *</label>
                            <DropDownList
                              style={{
                                backgroundColor: "white",
                              }}
                              data={materialContent}
                              name="MaterialContent"
                              textField="Description"
                              dataItemKey="_id"
                              value={dataItem.MaterialContent}
                              onChange={onChange}
                            />
                          </div>}
                      </div>
                    </fieldset>

                    <div className="row mt-3 mb-2">
                      <div className="col">
                        <Field
                          style={{ borderColor: "black" }}
                          name={"IsHardParted"}
                          component={Checkbox}
                          label={lang.is_hard_parted_label}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.IsHardParted}
                        />
                      </div>
                      <div className="col">
                        <Field
                          style={{ borderColor: "black" }}
                          name={"TXReady"}
                          component={Checkbox}
                          label={lang.transmission_label}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.TXReady}
                        />
                      </div>
                      <div className="col-2">
                        <Field
                          style={{ borderColor: "black" }}
                          name={"Archive"}
                          component={Checkbox}
                          label={lang.archive}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.Archive}
                        />
                      </div>
                      <div className="col-2">
                        <Field
                          style={{ borderColor: "black" }}
                          name={"IsDefault"}
                          component={Checkbox}
                          label={lang.is_default_label}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.IsDefault}
                        />
                      </div>
                      <div className="col-3" style={{ textAlign: "right" }} >
                        <ActionButton title={lang.generate_segments_button_text} name={lang.generate_segments_button_text} onClick={handleGenerateSegmentClick} />
                      </div>
                    </div>

                    <div className="row mt-3" style={{ marginBottom: "05px" }}>
                      <div className="col-12">
                        {/* to add data list here */}
                        <SegmentTypeCollectionTab
                          segmentDetails={segmentDetails}
                          updatedSegmentDetails={updatedSegmentDetails}
                          handleActualDuration={handleActualDuration}
                          generateSegment={generateSegment}
                          checkInvalidTimecodes={checkInvalidTimecodes}
                          checkExceedingSlotDuration={checkExceedingSlotDuration}
                          checkOverlappingTimecodes={checkOverlappingTimecodes}
                        />
                      </div>
                    </div>

                  </div>

                </div>
              </FormElement>
            )} />
          {/* </div> */}
        </div>
      </Splitter>
      {showChannelGroups && <CollectionSelection setDataList={handleChannelGroups} closeForm={() => setShowChannelGroups(false)} entityname={ENTITYNAME.ChannelGroups} width={"50vw"} title={lang.select_channel_groups_collection_header} addButtonTitle={lang.select_collection_button_text} />}

    </BossDialog>
  )
}

export default MultiVersioningForm